/* globals __DEVELOPMENT__, SENTRY_PUBLIC_KEY SENTRY_PROJECT_ID */

import Raven from 'raven-js';

Raven.config(`https://${SENTRY_PUBLIC_KEY}@sentry.io/${SENTRY_PROJECT_ID}`, {
  shouldSendCallback() {
    return !__DEVELOPMENT__;
  },
}).install();

export default Raven;



// WEBPACK FOOTER //
// ./app/src/vendor/Raven.js